import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import APIService from "../../Service/APIService";
import Card from "../../common/card";

const formatNumber = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    maximumFractionDigits: 2,
  });

const ManufacturerHomeTab = ({ filterButton }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isYTD = filterButton === "YTD";

  const [homeData, setHomeData] = useState(null);
  const [loading, setLoading] = useState(true);

  const getHomeData = async () => {
    try {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `getmanufacturerhomedata?ID=${id}`
      );
      return response?.data?.data;
    } catch (error) {
      console.error("Failed to fetch manufacturer home data", error);
      return null;
    }
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("user"));

    if (
      userData?.Type === "Manufacturer" &&
      String(id) !== String(userData?.ManufacturerID)
    ) {
      navigate("/");
      return;
    }

    getHomeData().then((data) => {
      setHomeData(data);
      setLoading(false);
    });
  }, [id, navigate]);

  const metrics = useMemo(() => {
    if (!homeData) return {};

    return {
      currentSales: isYTD
        ? homeData.CurrentSalesYTD
        : homeData.CurrentSalesMTD,

      activeAccounts: isYTD
        ? homeData.UniqueAccountsCountYTD
        : homeData.UniqueAccountsCountMTD,

      realizedSales: isYTD
        ? homeData.RealizedSalesYTD
        : homeData.RealizedSalesMTD,

      realizedInvoices: isYTD
        ? homeData.RealizedSalesInvoicesCountYTD
        : homeData.RealizedSalesInvoicesCountMTD,

      openBalance: homeData.OpenBalanceYTD,
      openBalanceInvoices: homeData.OpenBalanceInvoicesCountYTD,

      pastDue: homeData.PastDueYTD,
      pastDueInvoices: homeData.PastDueInvoicesCountYTD,
    };
  }, [homeData, isYTD]);

  return (
    <div className="home-card-wrapper">
      <Card
        loading={loading}
        cardTitle="Current Sales"
        cardTitleValue={formatNumber(metrics.currentSales)}
        cardBottomNumber={metrics.activeAccounts}
        cardBottomName="Active Accounts"
      />

      <Card
        loading={loading}
        cardTitle="Realized Sales"
        cardTitleValue={formatNumber(metrics.realizedSales)}
        cardBottomNumber={metrics.realizedInvoices}
        cardBottomName="Invoices"
      />

      <Card
        loading={loading}
        cardTitle="Open Balance"
        cardTitleValue={formatNumber(metrics.openBalance)}
        cardBottomNumber={metrics.openBalanceInvoices}
        cardBottomName="Invoices"
      />

      <Card
        loading={loading}
        cardTitle="Past Due"
        cardTitleValue={formatNumber(metrics.pastDue)}
        cardBottomNumber={metrics.pastDueInvoices}
        cardBottomName="Invoices"
        cardTitleValueColor="failureColor"
      />
    </div>
  );
};

export default ManufacturerHomeTab;
